import { TAppealInList, TAppealsList } from '../type'

const COMPLETED_STATUSES = ['COMPLETED', 'CANCELED'] as const

export const getActiveAppeals = (appeals: TAppealsList): TAppealsList =>
  appeals.filter(
    (item: TAppealInList) =>
      !COMPLETED_STATUSES.includes(
        item.status.status as (typeof COMPLETED_STATUSES)[number],
      ),
  )

export const getCompletedAppeals = (appeals: TAppealsList): TAppealsList =>
  appeals.filter((item: TAppealInList) =>
    COMPLETED_STATUSES.includes(
      item.status.status as (typeof COMPLETED_STATUSES)[number],
    ),
  )
